export default "__VITE_ASSET__DYHjuqwe__"